export default {
  computed: {
    earlyBirdValid() {
      return moment(this.event.datetime_eb).isAfter(new Date());
    },

    hasEarlyBird() {
      return this.event.datetime_eb
    },

    vatable() {
      return this.event.show_vat && this.event.vat_exclusive
    },

    earlyBirdInfo() {
      return (
        "Up To " +
        moment.parseZone(String(this.event.datetime_eb)).format("DD/MM/YYYY") +
        " at " +
        moment.parseZone(String(this.event.datetime_eb)).format("h:mm a")
      );
    },

    earlyBirdInfoExp() {
      return (
        "After " +
        moment.parseZone(String(this.event.datetime_eb)).format("DD/MM/YYYY") +
        " at " +
        moment.parseZone(String(this.event.datetime_eb)).format("h:mm a")
      );
    },

    topLineOverride() {
      return { borderTop: "4px solid " + this.event.phcolour };
    },

    showVatInTitle() {
      if (this.event.show_vat) {
        return "(" + (this.event.vat_exclusive ? "exc" : "inc") + " VAT)";
      } else {
        return "";
      }
    }
  }
}